<template>
    <div class="page-equipmentList">
        <div class="page-title">设备列表</div>
        <div class="page-btn-group">
            <el-button type="primary" @click="batchImageReplacement">批量更换形象</el-button>
            <el-button type="primary" @click="addEquipment">绑定设备</el-button>
        </div>
        <div class="page-table">
            <el-table :data="tableData" empty-text="暂无数据" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55" />
                <el-table-column label="序号" type="index" width="100" />
                <!-- <el-table-column label="设备型号" property=""></el-table-column> -->
                <el-table-column property="sn" label="设备序列号" />
                <el-table-column property="created_at" label="绑定时间" />
                <el-table-column label="当前数字人形象">
                    <template #default="scope">
                        <span>{{ scope.row.human.human_name }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                    <template #default="scope">
                        <el-button link type="primary" @click="changeImage(scope.row)">更换形象</el-button>
                        <el-button link type="primary" class="danger-btn" @click="unbindDevice(scope.row)">解绑设备</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="page-pagination">
                <el-pagination v-model:current-page="page" v-model:page-size="limit" background
                    layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="handleSizeChange"
                    @current-change="handleCurrentChange">
                </el-pagination>
            </div>
        </div>
        <!-- 绑定设备 -->
        <el-dialog v-model="bindDeviceVisible" title="绑定设备" width="30%">
            <el-form ref="formRef" :model="form" label-width="80px">
                <el-form-item label="SN码" required>
                    <el-input v-model="form.SNCode" placeholder="请输入设备SN码" />
                </el-form-item>
            </el-form>
            <div class="dialog-footer">
                <el-button type="primary" @click="bindDevice">验证并绑定</el-button>
            </div>
        </el-dialog>
        <!-- 更换形象 -->
        <el-dialog v-model="changeImageVisible" title="更换形象" width="40%">
            <div class="dialog-tips">确定更换当前设备形象？</div>
            <div class="select-image">
                <el-select v-model="huamnValue" placeholder="请选择形象">
                    <el-option v-for="item in imagesList" :key="item.id" :label="item.human_name" :value="item.id" />
                </el-select>
            </div>
            <div class="image-dialog-footer">
                <el-button type="primary" style="width: 80px;" @click="handleChangeImage">
                    确定
                </el-button>
                <el-button class="cancel-btn" style="width: 80px;" @click="handleCancelImage">取消</el-button>
            </div>
        </el-dialog>
        <!-- 解绑设备-->
        <el-dialog v-model="unbindDeviceVisible" title="解绑设备" width="40%">
            <div class="dialog-tips">确定解绑当前设备？</div>
            <div class="image-dialog-footer">
                <el-button type="primary" style="width: 80px;" @click="handleUnbindDevice">
                    确定
                </el-button>
                <el-button class="cancel-btn" style="width: 80px;" @click="handleCancelUnbindDevice">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { reactive, toRefs, onMounted } from 'vue';
import { ElMessage } from 'element-plus'
import { bindDeviceApi, deviceList, unbindDeviceApi, humanList, bindHuman } from '@/api/index'
export default {
    name: 'equipmentList',
    setup() {
        const state = reactive({
            bindDeviceVisible: false,//绑定设备弹窗
            changeImageVisible: false,//更换形象弹窗
            unbindDeviceVisible: false,//解绑设备弹窗
            form: {
                SNCode: ''
            },
            huamnValue: '',//形象
            tableData: [],
            selectDeviceList: [],//多选的设备列表
            imagesList: [],//形象列表
            total: 0,
            limit: 10,
            page: 1,
            curUnbindSn: '',//当前要解绑的设备sn码
            curChangeHumanDeviceId: '',//当前要更换形象的设备id
        })
        onMounted(() => {
            fetchDeviceList()
        })
        const fetchDeviceList = async () => {
            const params = {
                page: state.page,
                limit: state.limit
            }
            const res = await deviceList(params)
            if (res.code == 200) {
                state.tableData = res.data
                state.total = res.pagination.total
            } else {
                ElMessage.error('获取设备列表失败')
                state.tableData = []
            }
        }
        const addEquipment = () => {
            state.bindDeviceVisible = true
        }
        const bindDevice = async () => {
            const data = {
                sn: state.form.SNCode
            }
            const res = await bindDeviceApi(data)
            if (res.code == 200) {
                state.bindDeviceVisible = false
                state.form.SNCode = ''
                ElMessage.success('设备绑定成功')
                fetchDeviceList()
            } else {
                state.bindDeviceVisible = false
                state.form.SNCode = ''
                ElMessage.success('设备绑定失败,请检查SN码或网络环境')
            }
        }
        const handleSelectionChange = (val) => {
            const ids = val.map(item => item.id)
            state.selectDeviceList = ids
        }
        const batchImageReplacement = async() => {
            if (state.selectDeviceList.length === 0) {
                ElMessage.error('请选择设备')
                return
            }
            await fetchHumanList()
            state.changeImageVisible = true
        }
        const fetchHumanList =async()=>{
            const res = await humanList()
            if(res.code == 200){
                state.imagesList = res.data
            }else{
                ElMessage.error('数字人列表获取失败')
            }
        }
        const handleChangeImage = async () => {
            if (state.huamnValue == '') {
                ElMessage.error('请选择数字人')
                return
            } else {
                const data = {
                    device_ids: state.curChangeHumanDeviceId != '' ? [state.curChangeHumanDeviceId] :state.selectDeviceList,
                    human_id: state.huamnValue
                }
                const res = await bindHuman(data)
                if (res.code == 200) {
                    state.changeImageVisible = false
                    state.huamnValue = ''
                    state.curChangeHumanDeviceId = ''
                    ElMessage.success('数字人形象更换成功')
                    fetchDeviceList()
                }else{
                    state.changeImageVisible = false
                    state.huamnValue = ''
                    state.curChangeHumanDeviceId = ''
                    ElMessage.success('数字人形象更换失败')
                }
            }
        }
        const handleCancelImage = () => {
            state.curChangeHumanDeviceId = ''
            state.changeImageVisible = false
        }
        const handleUnbindDevice = async () => {
            const data = {
                sn: state.curUnbindSn
            }
            const res = await unbindDeviceApi(data)
            if (res.code == 200) {
                state.unbindDeviceVisible = false
                state.curUnbindSn = ''
                ElMessage.success('设备解绑成功')
                fetchDeviceList()
            } else {
                state.unbindDeviceVisible = false
                state.curUnbindSn = ''
                ElMessage.success('设备解绑失败')
            }
        }
        const handleCancelUnbindDevice = () => {
            state.unbindDeviceVisible = false
            state.curUnbindSn = ''
        }
        const changeImage = async (item) => {
            state.curChangeHumanDeviceId = item.id
            await fetchHumanList()
            state.changeImageVisible = true
        }
        const unbindDevice = (item) => {
            state.unbindDeviceVisible = true
            state.curUnbindSn = item.sn
        }
        const handleSizeChange = (val) => {
            state.limit = val
            //更新数据
            fetchDeviceList()
        }
        //切换页数
        const handleCurrentChange = (val) => {
            state.page = val
            //更新数据
            fetchDeviceList()
        }
        return {
            ...toRefs(state),
            bindDevice,
            addEquipment,
            handleSelectionChange,
            batchImageReplacement,
            handleChangeImage,
            handleCancelImage,
            handleUnbindDevice,
            handleCancelUnbindDevice,
            changeImage,
            unbindDevice,
            handleSizeChange,
            handleCurrentChange
        }
    }
}
</script>
<style lang="less" scoped>
.page-equipmentList {
    .page-title {
        color: #000;
        margin-top: 10px;
        margin-left: 20px;
        font-size: 22px;
    }

    .page-btn-group {
        margin-left: 20px;
        margin-top: 20px;
    }

    .page-table {
        width: 95%;
        margin-left: 20px;
        margin-top: 30px;
    }

    .danger-btn {
        color: #f56c6c;
    }

    .danger-btn:hover {
        color: #ff7878;
        cursor: pointer;
    }

    .dialog-footer {
        text-align: center;
        margin-top: 30px;
    }

    .dialog-tips {
        font-size: 16px;
        color: #333;
        margin-top: 20px;
        text-align: center;
    }

    .select-image {
        width: 50%;
        margin: 0 auto;
        margin-top: 20px;
    }

    .image-dialog-footer {
        margin-top: 40px;
        margin-bottom: 20px;
        text-align: center;

        .cancel-btn {
            margin-left: 100px;
        }
    }

    .page-pagination {
        margin-top: 20px;
        display: flex;
        justify-content: flex-end
    }
}
</style>